import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=3828a492&scoped=true&"
import script from "./wx.vue?vue&type=script&lang=js&"
export * from "./wx.vue?vue&type=script&lang=js&"
import style0 from "./wx.vue?vue&type=style&index=0&id=3828a492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828a492",
  null
  
)

export default component.exports